import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import ICONS from "../../../../../assets/Icons";
import SmallPopup from "../../../../../components/_utils/CommonSmallPopup";
import PrimaryStepper from "../../../../../components/_utils/CommonSteppers/PrimaryStepper";
import SVGComponent from "../../../../../components/_utils/SVGComponent";
import NameFieldCard from "../../../../../components/_utils/TransactionCommonComponents/NameFieldCard";
import {
  remitterAccountDetailsById,
  setRemitterAccountDetailsData,
} from "../../../../../redux/features/accounts/remitterAccount/remitterAccount";
import Loader from "../../../../../components/Loader/Index";

const RemitterAccountEditName = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [payload, setPayload] = useState({
    name: "",
  });
  const [openPopEdit, setOpenPopEdit] = useState(false);
  const [updateActive, setUpdateActive] = useState(false);
  const [isNextDisabled, setIsNextDisabled] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const { remitterAccountDetailsData, remitterAccountDetailsLoading } =
    useSelector((state) => state.remitterAccount);

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Update",
      previousEnableBgColor: "var(--primary-nav-act)",
      previousDisableBgColor: "var(--primary-nav-act)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsEnabled: !isNextDisabled,
      previousIsDisabled: updateActive,
      nextIsLoading: updateActive,
      nextLoaderNeeded: true,
      nextEnableBgColor: "var(--positive-act)",
      nextDisableBgColor: updateActive
        ? "var(--positive-act)"
        : "var(--text-disabled)",
      nextEnableTextColor: "var(--text-primary)",
      nextDisableTextColor: "var(--text-primary)",
      stepperText: "Remitter name",
    },
  ];

  const handleBack = () => {
    if (!hasUnsavedChanges) {
      navigate(
        `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/${id}`,
      );
    } else {
      setOpenPopEdit(true);
    }
  };

  const handleConfirm = () => {
    navigate(
      `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/${id}`,
    );
  };

  const handleUpdateAccount = () => {
    if (!payload.name || payload.name.trim() === "") return;

    dispatch(
      setRemitterAccountDetailsData({
        ...remitterAccountDetailsData,
        name: payload.name,
      }),
    );

    navigate(
      `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/success/${id}`,
      {
        state: {
          updatedName: payload.name,
        },
      },
    );
  };

  useEffect(() => {
    const isEmpty = !payload.name?.trim();

    const isSame =
      payload.name?.trim() === remitterAccountDetailsData?.name?.trim();

    setIsNextDisabled(isEmpty || isSame);
  }, [payload.name, remitterAccountDetailsData]);

  useEffect(() => {
    if (id) {
      dispatch(remitterAccountDetailsById({ id }));
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (remitterAccountDetailsData) {
      setPayload({
        name: remitterAccountDetailsData?.name || "",
      });
    }
  }, [remitterAccountDetailsData]);

  return (
    <>
      {openPopEdit && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <SmallPopup
            headerTitle={"Are you sure you want to leave this page?"}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            subtext="Leaving this page will exit you from current flow."
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setOpenPopEdit(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Leave"
            btnTwoBtnType="button"
            btnTwoHandleFunction={handleConfirm}
            btnTwoEnabledBgColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--primary-bg)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      {remitterAccountDetailsLoading ? (
        <div
          className={`absolute top-top-base z-z-index-fixed-ui h-height-full w-width-full flex justify-center items-center`}
        >
          <Loader />
        </div>
      ) : (
        <div className="w-width-full flex flex-col items-center h-full-height bg-primary-bg">
          <div className="w-width-full Qlg:bg-transparent bg-primary-nav">
            <div className="h-navbar-height hidden Qsmd:block"></div>
            <div className="h-[calc(var(--navbar-breadcrumb-height)-var(--navbar-height))] mb-margin-sm mt-margin-xs Qsmd:my-margin-base"></div>
          </div>

          <div className="flex justify-center items-end !bottom-bottom-base rounded-t-border-radius-md Qlg:bg-transparent bg-primary-nav rounded-b-border-radius-md w-screen fixed Qsmd:relative Qsmd:top-top-base left-left-base z-z-index-header flex-shrink-0 h-[var(--padding-bottom-unassign-cat)]">
            <PrimaryStepper
              activeStep={0}
              handleForwardAction={handleUpdateAccount}
              handleBackwardAction={handleBack}
              dataArray={dataArray}
            />
          </div>

          <div
            className="flex items-center w-width-full bg-primary-nav p-padding-sm h-mobile-create-header fixed left-left-base top-top-base z-z-index-header rounded-b-border-radius-md Qsmd:hidden"
            onClick={handleBack}
          >
            <SVGComponent
              color="var(--text-primary)"
              height="var(--icon-sm)"
              width="var(--icon-sm)"
              url={ICONS?.ARROW_LEFT_WHITE}
              alt="Icon"
            />
            <div className=" flex flex-col pl-padding-md gap-gap-xs">
              <p className=" text-font-md font-sans text-text-primary">
                Remitter Account
              </p>
              <p className="text-xs font-sans text-text-primary">
                Account name
              </p>
            </div>
          </div>

          <div className="w-full flex flex-col lg:flex-row justify-center gap-gap-xl pt-padding-md">
            <div className="w-full max-w-[var(--create-box-width)]">
              <NameFieldCard
                title="Account Name"
                placeholder="Account name"
                fieldName="remitter_name"
                value={payload.name}
                mode="soft"
                onChange={(val) => {
                  const cleaned = val.trimStart();
                  setPayload((prev) => ({
                    ...prev,
                    name: cleaned,
                  }));

                  setHasUnsavedChanges(
                    cleaned.trim() !== remitterAccountDetailsData?.name,
                  );
                }}
              />
            </div>

            <div className="w-full max-w-[var(--create-box-width)] invisible lg:visible"></div>
          </div>
        </div>
      )}
    </>
  );
};

export default RemitterAccountEditName;
